import {
  NEW_CUSTOMER_PAYMENTS,
  NEW_CUSTOMER_INVOICES,
  NEW_CUSTOMER_CONTRACTS,
  NEW_CUSTOMER_CREDIT_NOTES,
  NEW_SINGLE_CUSTOMER,
  NEW_CUSTOMERS,
  NEW_ALL_CUSTOMERS,
  NEW_CUSTOMER_PRODUCTS,
  NEW_CUSTOMERS_DEBT,
  NEW_CUSTOMER_UNPAID_INVOICES,
  ADD_CUSTOMER_PRODUCT,
  EDIT_CUSTOMER_PRODUCT,
  NEW_CUSTOMER_ACTIVITY,
  NEW_CUSTOMER_REMINDERS,
  NEW_CUSTOMER_NOTES,
  NEW_CUSTOMER_INVOICES_FILTERS,
  NEW_CUSTOMER_PAYMENTS_FILTERS,
  NEW_CUSTOMER_CONTRACTS_FILTERS,
  NEW_CUSTOMER_CREDIT_NOTES_FILTERS,
  NEW_CUSTOMER_NOTES_FILTERS,
  NEW_LOADING_TABLE,
  NEW_SEARCHING,
  NEW_CUSTOMER_TAXES,
  CUSTOMER_SUCURSAL_ALL,
  CUSTOMER_SUCURSAL_BYID,
  CUSTOMER_SUCURSAL_BASE

} from '../actions/customerActions';

import {
  RESET_ACCOUNT,
  LOG_OUT

} from '../actions/accountActions';

// JSON
import invoiceFilters from '../../data/invoiceFilters.json';

// Dependencies
import { matchPath } from "react-router";
import get from 'lodash/get';

const pathname = get(window, 'location.pathname');
const match = matchPath(pathname, {
  path: '/app/customer/:id',
  exact: true,
  strict: false
})
const uuid = get(match, 'params.id');
const defaultFilter = {
  label: 'Uuid del cliente',
  type: 'hide',
  filterKey: 'customer_id',
  personalized: true,
  value: uuid
}

const initialState = {
  allCustomers:[],
  customer: {},
  allCustomerSucursal:[],
  pageCustomerSucursal:1,
  countCustomerSucursal:0,
  pageIndexCustomerSucursal:1,
  customerSucursal:[],
  customerInvoices: [],
  customerPayments: [],
  customerContracts: [],
  customerCreditNotes: [],
  customerUnpaidInvoices: [],
  customerUnpaidInvoicesPages: 1,
  customersWithDebt: [],
  page: null,
  allProducts:[],
  customerActivity: [],
  customerNotes: [],
  customerReminders: [],
  customerInvoicesFilters: [ ...get(invoiceFilters, 'defaultActiveFiltersInvoice'), ...get(invoiceFilters, 'defaultTagFiltersInovice'), defaultFilter ],
  customerPaymentsFilters: [{
    label: 'Fecha pagos',
    filterKey: 'paid_at',
    type: 'date',
    filterCondition: 'btw',
    value: '',
    period: 'Todo'
  },{
    label: 'Buscar',
    filterKey: 'general',
    type: 'search',
    value: '',
    personalized: true
  },{
    label: 'Monto',
    filterKey: 'amount',
    type: 'amount',
    value: '',
    personalized: true
  },{
    label: 'Página',
    filterKey: 'page',
    type: 'page',
    value: 1,
    personalized: true
  },{
    label: 'Estado',
    filterKey: 'status',
    type:'options',
    options: [
      { label: 'Aceptados', value: 'confirmed' },
      { label: 'Pendientes', value: 'pending' },
      { label: 'Rechazados', value: 'reject' },
      { label: 'Cancelados', value: 'cancel'},
    ],
    value: 'confirmed,pending',
    personalized: true
  }, defaultFilter],
  customerContractsFilters: [{
    label: 'Fecha contratos',
    filterKey: 'started_at',
    type: 'date',
    filterCondition: 'btw',
    value: '',
    period: 'Todo'
  },{
    label: 'Buscar',
    filterKey: 'general',
    type: 'search',
    value: '',
    personalized: true
  },{
    label: 'Página',
    filterKey: 'page',
    type: 'page',
    value: 1,
    personalized: true
  },{
    label: 'Tabs',
    filterKey: 'status',
    type: 'tab',
    value: 'active', // => 'Vigentes'
    personalized: true
  },{
    label: 'Estado',
    filterKey: 'status',
    type:'options',
    options: [
      { label: 'Vigentes', value: 'active' },
      { label: 'Vencidos', value: 'inactive' },
      { label: 'Sin Fecha de Término', value: 'no_ended' },
    ],
    value: 'active,inactive,no_ended',
    personalized: true
  }, defaultFilter],
  customerCreditNotesFilters: [ ...get(invoiceFilters, 'defaultActiveFiltersInvoice'), ...get(invoiceFilters, 'defaultTagFiltersCreditNote'), defaultFilter],
  customerNotesFilters:[{
    label: 'Fecha de creación',
    filterKey: 'created_at',
    type: 'date',
    filterCondition: 'btw',
    value: '',
    period: 'Todo'
  },{
    label: 'Buscar',
    filterKey: 'general',
    type: 'search',
    value: '',
    personalized: true
  },{
    label: 'Página',
    filterKey: 'page',
    type: 'page',
    value: 1,
    personalized: true
  }, defaultFilter],
  customerRemindersFilters:[{
    label: 'Página',
    filterKey: 'page',
    type: 'page',
    value: 1,
    personalized: true
  }],
  searching: false,
  loadingTable: false,
  updateTable: true,
  customerTaxes: []

} // END initialState

export default function (state = initialState, action) {
  let { payload } = action, newState;
  switch (action.type) {
    case NEW_CUSTOMER_PAYMENTS:
      newState = { customerPayments: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_INVOICES:
      newState = { customerInvoices: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_CONTRACTS:
      newState = { customerContracts: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_CREDIT_NOTES:
      newState = { customerCreditNotes: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_UNPAID_INVOICES:
      newState = {
        customerUnpaidInvoices: get(payload, 'data', []),
        customerUnpaidInvoicesPages: payload.pages ? payload.pages : state.customerUnpaidInvoicesPages
      };
      return { ...state, ...newState };

    case NEW_SINGLE_CUSTOMER:
      newState = { customer: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMERS:
      newState = { page: payload };
      return { ...state, ...newState };

    case NEW_ALL_CUSTOMERS:
      newState = { allCustomers: payload};
      return { ...state, ...newState };

    case NEW_CUSTOMERS_DEBT:
      newState = { customersWithDebt: payload};
      return { ...state, ...newState };

    case NEW_CUSTOMER_PRODUCTS:
      newState = { allProducts: payload};
      return { ...state, ...newState };

    case ADD_CUSTOMER_PRODUCT:
      newState = { allProducts: [ ...state.allProducts, payload ] };
      return { ...state, ...newState };

    case EDIT_CUSTOMER_PRODUCT:
      newState = { allProducts: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_ACTIVITY:
      newState = { customerActivity: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_NOTES:
      newState = { customerNotes: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_REMINDERS:
      newState = { customerReminders: get(payload, 'data') };
      return { ...state, ...newState };

    case NEW_CUSTOMER_TAXES:
      newState = { customerTaxes: payload };
      return { ...state, ...newState };

    case NEW_CUSTOMER_INVOICES_FILTERS:
      newState = { customerInvoicesFilters: payload.filters , updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_CUSTOMER_PAYMENTS_FILTERS:
      newState = { customerPaymentsFilters: payload.filters , updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_CUSTOMER_CONTRACTS_FILTERS:
      newState = { customerContractsFilters: payload.filters , updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_CUSTOMER_CREDIT_NOTES_FILTERS:
      newState = { customerCreditNotesFilters: payload.filters , updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_CUSTOMER_NOTES_FILTERS:
      newState = { customerNotesFilters: payload.filters , updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_LOADING_TABLE:
      newState = { loadingTable: payload };
      return { ...state, ...newState };

    case CUSTOMER_SUCURSAL_ALL:
        return { ...state, allCustomerSucursal:payload.data.children,pageCustomerSucursal:payload.data.totalPages,countCustomerSucursal:payload.data.totalRecords,pageIndexCustomerSucursal:payload.data.currentPage };
    case CUSTOMER_SUCURSAL_BYID:
        return{...state, customerSucursal:action.payload.data}
    case NEW_SEARCHING:
      newState = { searching: payload };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState }
      return { ...state, ...initialState };

    default:
      return state;

  }

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/customerReducer.js